import React from "react";

export default function CTABlock({ data }) {
  return (
    <div
      style={{
        marginTop: "30px",
        padding: "40px",
        background: "linear-gradient(135deg, #6C63FF, #FF6584)",
        borderRadius: "15px",
        textAlign: "center",
        color: "white",
      }}
    >
      <h2>{data.title || "Call To Action"}</h2>
      <button
        style={{
          marginTop: "15px",
          padding: "12px 22px",
          background: "#fff",
          borderRadius: "8px",
          border: "none",
          color: "#111",
          fontWeight: "bold",
        }}
      >
        {data.buttonText || "Click Here"}
      </button>
    </div>
  );
}
